import '../App.css';
import React from 'react';
import {useLanguage} from "../LanguageContext";
import {getTranslation} from "../consts/translations";

interface FooterProps {
    showExitButton: boolean,
    onExit: () => void
}

const Footer: React.FC<FooterProps> = (props: FooterProps) => {
    const {language} = useLanguage();
    const translation = getTranslation(language);

    return (
        <div className="login-footer">
            <div className="footer-content">
                <p>
                    {translation.footer_paragraph}
                    <br/>
                    <a href="mailto:acmg.support@psifas.org.il">acmg.support@psifas.org.il</a>
                </p>
                {props.showExitButton &&
                    <button className="exit-button" onClick={props.onExit}>{translation.exit_text}</button>}

            </div>
        </div>
    );
}

export default Footer;
